import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, keywords, image }) => {
  // Default values if not provided
  const defaultTitle = 'The Code-E Project | Frontend Web Development Resources';
  const defaultDescription = 'Master frontend web development with our black-and-white guide to HTML, CSS, JavaScript, Bootstrap, and more.';
  const defaultKeywords = 'HTML, CSS, JavaScript, Bootstrap, VS Code, MongoDB, frontend development, web development, coding tutorials';
  const defaultImage = '/og-image.jpg';
  const siteUrl = 'https://codie.codes';

  // Use provided values or defaults
  const seoTitle = title || defaultTitle;
  const seoDescription = description || defaultDescription;
  const seoKeywords = keywords || defaultKeywords;
  const seoImage = image || defaultImage;

  return (
    <Helmet>
      {/* Basic meta tags */}
      <title>{seoTitle}</title>
      <meta name="description" content={seoDescription} />
      <meta name="keywords" content={seoKeywords} />
      
      {/* OpenGraph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={seoTitle} />
      <meta property="og:description" content={seoDescription} />
      <meta property="og:image" content={`${siteUrl}${seoImage}`} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={siteUrl} />
      <meta property="twitter:title" content={seoTitle} />
      <meta property="twitter:description" content={seoDescription} />
      <meta property="twitter:image" content={`${siteUrl}${seoImage}`} />
    </Helmet>
  );
};

export default SEO; 